export enum BaseColor {
  Red = 'red',
  Orange = 'orange',
  Yellow = 'yellow',
  Green = 'green',
  Blue = 'blue',
  Grey = 'grey',
}

export const COLOR_PALETTE = {
  [BaseColor.Red]: {
    lighter: '#ffe8ec',
    light: '#ffb5c0',
    base: '#ff3652',
    dark: '#ff0326',
    darker: '#cf001d',
  },
  [BaseColor.Orange]: {
    lighter: '#ffe3cc',
    light: '#ffb980',
    base: '#ff7300',
    dark: '#cc5c00',
    darker: '#994500',
  },
  [BaseColor.Yellow]: {
    lighter: '#fff9d2',
    light: '#fff29f',
    base: '#ffe539',
    dark: '#ffde06',
    darker: '#d2b600',
  },
  [BaseColor.Green]: {
    lighter: '#eef8dc',
    light: '#dbefb2',
    base: '#a9d948',
    dark: '#91c529',
    darker: '#729b20',
  },
  [BaseColor.Blue]: {
    lighter: '#ccebff',
    light: '#80ceff',
    base: '#009dff',
    dark: '#007ecc',
    darker: '#005e99',
  },
  [BaseColor.Grey]: {
    white: '#fff',
    lightest: '#f9f9f9',
    lighter: '#f2f2f2',
    light: '#ebebeb',
    base: '#b8b8b8',
    dark: '#787878',
    darker: '#404040',
    black: '#000',
  },
} as const;
